<script>
    import R, {LOADER} from "../lib/js/requests";
    import {RESERVATION_STATUS} from "../lib/js/constants.js";
    import app from "../lib/stores/app.js";
    import {copyObject, getDepartmentCode, scrollToTop} from "../lib/js/utils.js";
    import PageHeader from "../lib/components/PageHeader.svelte";
    import Step1 from "./Step1.svelte";
    import Step2 from "./Step2.svelte";
    import CheckoutPage from "../book/CheckoutPage.svelte";

    export let reservation;

    let vehicles = [];
    let step = 0;


    const initialize = () => {
        if (reservation == null) {
            const link_code = getDepartmentCode();
            window.location.href = `/${link_code}`;
            return;
        }

        // transfer.time = "00:00";

        // initialize vehicles
        $app.vehicle_types.map(item => {
            vehicles.push(copyObject(item));
        });

        // Check if this is a retry and reload transfer data
        const params = new URLSearchParams(window.location.search);
        const ref = params.get('ref');
        if (ref) {
            loadPayment(ref);
        }
        step = 1;
    }

    const onNextStep = step_no => {
        step = step_no;
        scrollToTop();
    }

    const onPreviousStep = step_no => {
        step = step_no;
        scrollToTop();
    }



    const loadPayment = ref => {
        const onSuccess = result => {
            if (result.status == RESERVATION_STATUS.COMPLETED) {
                // Do nothing!
                return;
            }

            // Get transfer details from data
            transfer = result.data;
            if (result.price) {
                transfer.price = result.price;
            }
            step = 3;
        }

        const onFailure = err => {
        };

        R.handle(R.reservation.details, ref, onSuccess, onFailure, LOADER.POPUP);
    }

    initialize();
</script>

<PageHeader title="Transfer reservation"/>

{#if step > 0}
    <div class="container py-lg">
        {#if step == 1}
            <Step1 bind:reservation onNext={() => onNextStep(2)}/>
        {/if}

        {#if step == 2}
            <Step2 bind:reservation onNext={() => onNextStep(3)} onBack={() => onPreviousStep(1)}/>
        {/if}

        {#if step == 3}
            <CheckoutPage bind:reservation onBack={() => onPreviousStep(2)} />
        {/if}
    </div>
{/if}